import '@fontsource-variable/reddit-sans'

import {
  GlobalStyle,
  initializeSmartyStreets,
  WillowThemeProvider,
} from '@branch-messenger/willow-ui'
import { QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { App } from './App.tsx'
import { queryClient } from './lib/query-client.ts'
import { initializeAnalytics } from './lib/sentry.ts'

initializeAnalytics()
initializeSmartyStreets(import.meta.env.VITE_SMARTY_AUTH_ID)

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <WillowThemeProvider themeMode="light">
        <App />
        <GlobalStyle />
      </WillowThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
